<template>
  <fragment>
    <transition name="fade" mode="out-in">
      <slot v-if="adultContentAllowed"></slot>
    </transition>
    <transition name="fade" mode="out-in">
      <slot v-if="!adultContentAllowed" name="adultContentCover"></slot>
    </transition>
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AdultContentSwitcher",
  computed: {
    ...mapGetters({
      adultContentAllowed: "currentUser/adultContentAllowed",
    }),
  },
  created() {
    this.fetchAdultContentCookie();
  },
  methods: {
    ...mapActions({
      fetchAdultContentCookie: "currentUser/fetchAdultContentCookie",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.fade-enter-active {
  transition: opacity $transition-duration;
}

.fade-leave {
  display: none;
}

.fade-enter {
  opacity: 0;
}
</style>
